import { useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import { useHistory } from 'react-router';
import { toast } from 'react-toastify';
import { useAppContext } from '../../../appProvider/contextProvider';
import { ERRORS, URL_VALIDATOR } from '../../../constants/AppConstants';
import { addRssFeeds, deleteRssFeed, getRssFeeds, updateRssFeed } from '../../../services/automationService';



const RssSetup = () => {

    const history = useHistory();

    const {selectedWebsite}  = useAppContext();

    const [feeds, setFeeds] = useState([]);

    const [ rssUrl, setRssUrl ] = useState('');
    const [ rssUrlError, setRssUrlError ] = useState(null);

    const [rssType, setRssType] = useState('xml');

    const [rssEditIndex, setRssEditIndex] = useState(null);


    useQuery(
        ['fetchRssFeeds', selectedWebsite?.id], 
        () => getRssFeeds(selectedWebsite?.id),
        {
            enabled: !!selectedWebsite,
            onSuccess:(feeds) => {
                if(feeds.errors) {

                } else{
                    setFeeds(feeds);
                }
            }
        }
    )

    const handelRssUrlChange = (value) => {
        setRssUrl(value);
        if(!value.match(URL_VALIDATOR)) {
            setRssUrlError(ERRORS.WEBSITE_URL_VALID);
        } else {
            setRssUrlError(null);
        }
    }

    const isAddDisabled = () => {
        return rssUrl.length <= 0 || rssUrlError;
    }

    const addRssURl = useMutation((event) => {
        event.preventDefault();
        const rssData = {
            url: rssUrl,
            is_active: true,
            type: rssType,
        }
        return addRssFeeds(selectedWebsite?.id, rssData);
    }, {
       onSuccess: (rssFeed) => {
           if(rssFeed.errors || rssFeed.error) {
                if(['FeedXMLError', 'FeedJSONError', 'FeedATOMError', 'FeedParseError'].includes(rssFeed.errors.url[0])) {
                    toast.error('Rss Feed url is not valid');
                } else if(rssFeed.errors.url === 'url_exists') {
                    toast.error(ERRORS[rssFeed.errors.url]);
                }
                else if(rssFeed.errors.url && rssFeed.errors.url[0]) {
                    toast.error(ERRORS[rssFeed.errors.url[0]]);
                } else {
                    toast.error('Entered feed url is not valid');
                }
           } else {
               const newRssFeeds = [rssFeed, ...feeds];
               toast.success('Rss added successfully');
               setFeeds(newRssFeeds);
               cancelEdit();
           }
       }
    });


    const editRss = (url, type, index) => {
        setRssUrlError(null);
        setRssUrl(url);
        setRssType(type)
        setRssEditIndex(index);
    }

    const cancelEdit = () => {
        setRssUrlError(null);
        setRssUrl('');
        setRssType('xml');
        setRssEditIndex(null);
    }


    const updateFeed = useMutation((rssId) =>{
        return updateRssFeed(
            selectedWebsite?.id,
            {
                url: rssUrl,
                is_active: true,
                type: rssType,
            },
            rssId
            );
    }, {
        onSuccess: (rssFeed) => {
            if(rssFeed.errors || rssFeed.error) {

            } else {
                const newFeeds =  feeds.map((feed) => {
                    if(feed.id === rssFeed.id) {
                        return rssFeed;
                    }
                    return feed;
                });
                setFeeds(newFeeds);
                cancelEdit();
                toast.success('Rss Feed updated successfully');
            }
        }
    });

    const updateRss = (event, rssId) => {
        event.preventDefault();
        updateFeed.mutate(rssId);
    }

    const deleteFeed = useMutation((rssId) => {
        return deleteRssFeed(selectedWebsite.id, rssId);
    }, {
        onSuccess: (rssFeed, rssId) => {
            if(rssFeed.errors || rssFeed.error) {

            } else {
                const leftRssFeed = feeds.filter(({id}) => id !== rssId);
                setFeeds(leftRssFeed);
                toast.success('Rss Feed deleted successfully')
                // const leftRss = feeds.filter
            }
        }
    });

    const deleteRss = (event, rssId) => {
        event.preventDefault();
        deleteFeed.mutate(rssId);
    }

    return <>
        <div className="panel full-height">
            <div className="panel-header">
                <div className="d-flex justify-content-between align-items-center">
                    <h3 className="mb-0"><i className="icon icon-chevron-left mr-2" onClick={() => history.goBack()}></i>RSS Setup</h3>
                    {/* <button className="btn btn-primary"><i className="icon icon-add"></i> Add New Website</button> */}
                </div>                                
            </div>
            <div className="panel-body full-height scrollable_y">
                {/* <div className="d-flex justify-content-between">
                    <p className="regular text-dark py-2">Add or remove topics of interest that your readers can subscribe to.</p>
                    <label className="toggle-control toggle-control-sm mb-2">
                        <input type="checkbox" checked={is_enabled} onChange={disableTopicFeature.mutate} />
                        <span className="control"></span>
                    </label>
                </div> */}
                <div className="table-responsive scrollable_y">
                    <table className="table table-hover topics-table">    
                        <colgroup>
                            <col width="78%"/>
                            <col width="10%"/>
                            <col width="12%"/>
                        </colgroup>                                    
                        <thead>                                            
                            <tr>
                                <th>RSS Feed Url</th>
                                <th>Type</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <div className="form-group mb-0">           
                                        <input 
                                            type="text"
                                            placeholder="Enter Rss Feed URL" 
                                            className="form-control"
                                            value={ rssEditIndex === null ? rssUrl : ''}
                                            onChange={({target}) => handelRssUrlChange(target.value)}
                                            disabled = {rssEditIndex !== null}
                                            // onBlur={handelTopicValidation}
                                        />
                                    </div>
                                    {(rssUrlError && rssEditIndex === null) && <span className="error-message">{rssUrlError}</span>}
                                </td>
                                <td>
                                <div className="form-group mb-0">                   
                                        <select
                                            className="form-control"
                                            value={rssEditIndex === null ? rssType: ''}
                                            onChange={({target}) => setRssType(target.value)} 
                                            disabled = {rssEditIndex !== null}
                                        > 
                                            <option value={'xml'} >XML</option>
                                            <option value={'json'} >JSON</option>
                                            <option value={'atom'}>ATOM</option>
                                        </select>
                                    </div>
                                </td>
                                <td colSpan="3">
                                    <button
                                        onClick={addRssURl.mutate} 
                                        disabled={isAddDisabled() || rssEditIndex !== null}
                                        className="btn btn-block btn-primary">
                                            <i className="icon icon-add mr-1"></i>Add
                                        </button>
                                </td>
                            </tr>
                            {
                                feeds.map((topic, index) => <tr key={index}>
                                    {
                                        rssEditIndex  === index ? <>
                                            <td>
                                                <div className="form-group mb-0">                   
                                                    <input 
                                                        type="text"
                                                        placeholder="Enter Rss Feed URL" 
                                                        className="form-control"
                                                        value={rssUrl}
                                                        onChange={({target}) => handelRssUrlChange(target.value)}
                                                        // onBlur={handelTopicValidation}
                                                    />
                                                </div>
                                                {rssUrlError && <span className="error-message">{rssUrlError}</span>}
                                            </td>
                                            <td>
                                            <div className="form-group mb-0">                   
                                                    <select
                                                        className="form-control"
                                                        value={rssType}
                                                        onChange={({target}) => setRssType(target.value)} 
                                                    > 
                                                        <option value={'xml'} >XML</option>
                                                        <option value={'json'} >JSON</option>
                                                        <option value={'atom'}>ATOM</option>
                                                    </select>
                                                </div>
                                            </td>
                                            <td className="d-flex justify-content-around">
                                                <button 
                                                    className="btn btn-primary" 
                                                    disabled={isAddDisabled()}
                                                    onClick={(event) => updateRss(event, topic.id)}
                                                >
                                                    Update
                                                </button>
                                                <button className="btn btn-danger" onClick={() => cancelEdit()} >
                                                    <i className="icon icon-close"></i>
                                                </button>   
                                            </td>
                                        </>
                                        : <> 
                                            <td>{topic.url}</td>
                                            <td className="text-center" style={{textTransform: 'uppercase'}}>{topic.type}</td>
                                            <td className="d-flex justify-content-around">
                                                <button 
                                                    className="btn btn-outline" 
                                                    onClick={() => editRss(topic.url, topic.type,index)} 
                                                >
                                                    <i className="icon icon-edit"></i>
                                                </button>
                                                <button 
                                                    className="btn btn-danger"
                                                    onClick={(event) => deleteRss(event, topic.id)}     
                                                >
                                                    <i className="icon icon-delete" ></i>
                                                </button>   
                                            </td>
                                    </>
                                
                                    }
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

    </>
}

export default RssSetup;